import { GET_USER_PROFILE_REQUEST, GET_USER_PROFILE_SUCCESS, GET_USER_PROFILE_FAILURE } from '../../constants/get_user_profile.constants';

export const getUserProfileRequest = id => ({
    type: GET_USER_PROFILE_REQUEST, id,
});

export const getUserProfileRequestSuccess = (profile, options) => ({
    type: GET_USER_PROFILE_SUCCESS, profile, options,
});

export const getUserProfileRequestFailure = error => ({
    type: GET_USER_PROFILE_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_profile_actions/get_user_profile.actions.js